// Google Analytics 4. Loads only when a Measurement ID is set in Admin -> Site -> Google Analytics.
// Everything here is a safe no-op until then (and in the build-time prerender), so callers never need to check.
let loadedId = null;

export const gaReady = () => Boolean(loadedId && window.gtag);

export const initGA = (id) => {
  if (!id || loadedId === id || typeof document === 'undefined') return;
  loadedId = id;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };      // eslint-disable-line prefer-rest-params
  window.gtag('js', new Date());
  // page views are sent manually on every route change (this is a single-page app)
  window.gtag('config', id, { send_page_view: false, anonymize_ip: true });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);
};

export const gaPageView = (path) => {
  if (!gaReady()) return;
  window.gtag('event', 'page_view', { page_path: path, page_location: window.location.href, page_title: document.title });
};

export const gaEvent = (name, params = {}) => {
  if (!gaReady()) return;
  window.gtag('event', name, params);
};
